"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampledData = void 0;
/**
 * A series of measurements taken by a device, with upper and lower limits. There may be more than one dimension in the data.
 */
var SampledData = /** @class */ (function () {
    function SampledData() {
    }
    return SampledData;
}());
exports.SampledData = SampledData;
